export const initialDistributionColumns: Record<string, any>[] = [
  {
    label: "Description:",
    column: "description",
    type: "array",
  },
  {
    label: "Documentation:",
    column: "page",
    type: "hyperlink",
  },
  {
    label: "Access URL:",
    column: "accessURL",
    type: "hyperlink",
  },
  {
    label: "Access Service:",
    column: { accessService: ["id", "title", "endPointURL"] },
    type: "ref",
  },
  {
    label: "Download URL:",
    column: "downloadURL",
    type: "hyperlink",
  },
  {
    label: "Availability:",
    column: "availability",
    type: "hyperlink",
  },
  {
    label: "Format:",
    column: "format",
    type: "hyperlink",
  },
  {
    label: "Media Type:",
    column: "mediaType",
    type: "hyperlink",
  },
  {
    label: "Status:",
    column: { status: ["name", "label", "ontologyTermURI"] },
    type: "ref",
  },
  {
    label: "Compression Format:",
    column: "compressFormat",
    type: "hyperlink",
  },
  {
    label: "Packaging Format:",
    column: "packageFormat",
    type: "hyperlink",
  },
  {
    label: "Image Size (in GB):",
    column: "byteSize",
    type: "string",
  },
  {
    label: "Spatial Resolution:",
    column: "spatialResolutionInMeters",
    type: "string",
  },
  {
    label: "Temporal Resolution:",
    column: "temporal",
    type: "string",
  },
  {
    label: "Checksum:",
    column: {
      checksum: [{ algorithm: ["name", "label", "ontologyTermURI"] }],
    },
    type: "nested_ref",
  },
  {
    label: "Linked Schemas:",
    column: "conformsTo",
    type: "hyperlink",
  },
  {
    label: "Language:",
    column: { language: ["name", "label", "ontologyTermURI"] },
    type: "mref",
  },
  {
    label: "Applicable Legislation:",
    column: "applicableLegislation",
    type: "hyperlink",
  },
  {
    label: "License:",
    column: "license",
    type: "hyperlink",
  },
  {
    label: "Access Conditions:",
    column: { rights: ["id", "label"] },
    type: "ref",
  },
  {
    label: "Release Date:",
    column: "issued",
    type: "date",
  },
  { 
    label: "Modification Date:",
    column: "modified",
    type: "date",
  },
  {
    column: [
      "title",
      "id",
    ],
  },
];

export default initialDistributionColumns;
